import React, {useEffect, useState} from 'react';
import {Accordion} from '../Accordion/LocalizedAccordion';
import {t} from 'i18next';
import {DropdownInput, LanguageSelection} from './LanguagePicker.style';
import {isNullOrEmpty} from '../../utils';
import {generateIdentifier} from '../../utils/IdentityUtils';
import {DropdownMultipleValueProps, DropdownOptionProps} from '../../models/DropdownProps';
import {
    DROPDOWN_OPTION,
    getDropdownOptionProps,
    getEmptyDropdownOptionProps,
    SELECT_LANGUAGE,
    SELECT_PREFIX
} from '../../utils/DropdownOptionPropsUtils';

export const LanguagePicker: React.VFC<DropdownMultipleValueProps<string>> = (props) => {
    const getOptions = (languageSelectionState: string[]): DropdownOptionProps[] => {
        let options: DropdownOptionProps[] = [];
        let localeItem: DropdownOptionProps = getEmptyDropdownOptionProps(SELECT_LANGUAGE, SELECT_LANGUAGE, DROPDOWN_OPTION);
        options.push(localeItem);
        props.dataSource.filter(language => (isNullOrEmpty(language.value)
            || (!languageSelectionState.includes(language.name))))
            .map(language => {
                localeItem = {
                    name: SELECT_PREFIX.concat(language.name),
                    value: language.value
                } as DropdownOptionProps;
                options.push(localeItem);
            });

        return getDropdownOptionProps(options, SELECT_LANGUAGE, DROPDOWN_OPTION);
    };

    const [languageSelection, setLanguageSelection] = useState<string[]>([]);
    const [languageInput, setLanguageInput] = useState<string>(props.defaultValue ? props.defaultValue : '');
    const [languageOptions, setLanguageOptions] = useState<DropdownOptionProps[]>(getOptions([]));

    const setState = (selectionState: string[], selectionOptions: DropdownOptionProps[], resetInput: boolean) => {
        setLanguageSelection(selectionState);
        props.onChange(selectionState);
        setLanguageOptions(selectionOptions);
        if (resetInput) {
            setLanguageInput('');
        }
    };

    useEffect(() => {
        setLanguageOptions(getOptions([]));
    }, [props.dataSource]);

    useEffect(() => {
        if (props.resetState) {
            setState([], getOptions([]), true);
        }
    }, [props.resetState]);

    const handleInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let eventValue = e.target.value.toString();
        setLanguageInput(eventValue);
        let selectionOptions = languageOptions;
        let selectionState = [eventValue];
        if (props.resetInput) {
            selectionOptions = languageOptions.filter(language => (language.value !== eventValue));
            selectionState = [...languageSelection];
            if (!languageSelection.includes(eventValue)) {
                selectionState = selectionState.concat(eventValue);
            }
        }
        setState(selectionState, selectionOptions, props.resetInput);
    };

    const handleDelete = (languageKey: string) => {
        let selectionState = languageSelection.filter(language => (language !== languageKey));
        setState(selectionState, getOptions(selectionState), true);
    };

    const getLabel = (language: string) => {
        let label = '';
        if (language) {
            label = language;
        }

        return label;
    };

    return (
        <Accordion localizedHeadline={t('LANGUAGE_PICKER_CAPTION')}>
            <DropdownInput id={generateIdentifier('languageId_'.concat(languageInput))}
                           defaultValue={props.defaultValue ? props.defaultValue : ''}
                           value={languageInput}
                           options={languageOptions}
                           disabled={props.disabled}
                           onChange={handleInput}/>
            {languageSelection?.map(language => {
                return props.resetInput &&
                    <LanguageSelection id={generateIdentifier(language)}
                                       key={language}
                                       label={getLabel(language)}
                                       buttonClose
                                       onClose={() => handleDelete(language)}/>;
            })}
        </Accordion>
    );
};
